<div id="communityPolicy" class="body-container policy-container">
  <span [marked]="communityPolicyText"></span>
</div>
